<template>
	<div class="container-fluid">
		<div class="card">
      <div class="card-header">
        <h2 class="card-title">Cambiar contraseña</h2>
      </div>
      <div class="card-body">
        <form @submit.prevent="cambiar_passwords" class="container">
          <div class="form-group row">
            <label for="inputPassword1" class="col-sm-3 col-form-label">Contraseña actual</label>
            <div class="col-sm-9">
              <input v-model="passwordActual" type="password" class="form-control" id="inputPassword1">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputPassword2" class="col-sm-3 col-form-label">Contraseña nueva</label>
            <div class="col-sm-9">
              <input v-model="passwordNuevo" type="password" class="form-control" id="inputPassword2">
            </div>
          </div>
          <div class="form-group row">
            <label for="inputPassword3" class="col-sm-3 col-form-label">Confirmar contraseña</label>
            <div class="col-sm-9">
              <input v-model="confirmacion" type="password" class="form-control" id="inputPassword3">
            </div>
          </div>
          <br />
          <div class="form-group row">
            <div class="d-flex col-md-4 offset-md-8">
              <button class="btn btn-bpb-primary btn-block">Guardar</button>
            </div>
          </div>
        </form>
      </div>
    </div>
	</div>
</template>

<script type="text/javascript">
  import api from '@/api/account'

  export default {
    data: function() {
      return {
        passwordActual: null
        ,passwordNuevo: null
        ,confirmacion: null
      }
    }
    ,methods: {
      cambiar_passwords: async function() {
        if (this.passwordNuevo != this.confirmacion)
          return this.$swal('Error','La contraseña y la confirmación no coinciden','error');

        try {
          let res = (await api.cambiar_password({
            oldpassword: this.passwordActual
            ,password: this.passwordNuevo
            ,password_confirmation: this.confirmacion
          }));

          this.$log.info('res', res);
          this.$swal('Exito!','La contraseña se actualizó correctamente','success');
          this.passwordActual = null;
          this.passwordNuevo = null;
          this.confirmacion = null;
        }catch(e) {
          this.$log.info('err',e);
          this.$swal('Error','Error al cambiar la contraseña: '+e.message,'error');
        }
      }
    }
  }
</script>